import antdEn from 'antd/lib/locale-provider/en_US';
import appLocaleData from 'react-intl/locale-data/en';
import enMessages from './en.json';

const enUS = {
    messages: {
        ...enMessages,
    },
    antd: antdEn,
    locale: 'en-US',
    data: appLocaleData,
};

export default enUS;



// WEBPACK FOOTER //
// ./src/locales/en-US.js